var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._b({class:_vm.type === 'file' ? '' : 'form-control',domProps:{"value":_vm.type === 'file' ? '' : _vm.val},on:{"input":_vm._onInput,"change":_vm._onChange}},'input',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }